import $ from 'jquery';

export default function awardSliderGroup() {
    var previous = $().isWelshPage() ? 'Blaenorol' : 'Previous',
        next     = $().isWelshPage() ? 'Nesaf' : 'Next';

    $('.award-slider-group').slick({
        prevArrow: `<button class="slick-prev" aria-label="${previous}" type="button">${previous}</button>`,
        nextArrow: `<button class="slick-next" aria-label="${next}" type="button">${next}</button>`,
        infinite: true,
        speed: 100,
        dots: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 850,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }
        ]
    });
}
